// @flow
import * as React from 'react';

import { appLoaded } from '~/core/state/application/actions';
import { connectWithLifecycle } from 'react-lifecycle-component';
import Cookie from '<drivers>/cookie';
import CookiePolicyAlert from '~/components/widgets/cookie-policy';
import ErrorBoundary from '~/components/error-boundary';
import { getTranslations } from '~/core/state/translations/selectors';
import { getUserLocale } from '~/core/state/application/selectors';
import Global from '~/components/global';
import hiveTheme from '~/core/themes/main';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from '~/routes';
import { ThemeProvider } from 'styled-components';
import RavenUserSetup from '~/components/raven-user-setup';
import { UAUserSetup } from '~/components/universal-analytics';

type stateProps = {
    locale: string,
    key: string,
    messages: Object
};

const mapStateToProps = (state: Object): stateProps => {
    const locale = getUserLocale(state);
    const translations = getTranslations(state);

    return {
        locale,
        defaultLocale: locale,
        key: locale,
        messages: translations && translations.toJS()
    };
};

const mapDistpatchToProps = { appLoaded };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { appLoaded } = dispatchProps;
    const { locale } = stateProps;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        componentWillMount: () => appLoaded({ locale })
    };
}

const ConnectedIntlProvider = connectWithLifecycle(mapStateToProps, mapDistpatchToProps, mergeProps)(IntlProvider);

type Props = {
    store: Object,
    children?: React.Node
};

function devToolsComponentWhenDevMode(isDev) {
    if (isDev) {
        return require('~/components/dev-tools').default;
    }

    return null;
}

export default function Root({ children, store }: Props) {
    let DevTools;

    const isDev = process.env.NODE_ENV === 'development';
    const HiveDevTools = devToolsComponentWhenDevMode(isDev);

    const allowDevTools = process.env.REACT_APP_DEVTOOLS;

    if (allowDevTools) {
        DevTools = require('<drivers>/dev-tools').default;

        const immutable = require('immutable');
        const installDevTools = require('immutable-devtools');
        installDevTools(immutable);
    }

    const cookieAccepted = Cookie.get('cookie-accepted');

    return (
        <Provider store={store}>
            <ConnectedIntlProvider>
                <RavenUserSetup>
                    <ThemeProvider theme={hiveTheme}>
                        <ErrorBoundary>
                            <Router>
                                <UAUserSetup>
                                    <Global>
                                        {!cookieAccepted && <CookiePolicyAlert />}
                                        {children || <Routes />}
                                        {isDev && HiveDevTools && <HiveDevTools />}
                                        {allowDevTools && DevTools ? <DevTools /> : false}
                                    </Global>
                                </UAUserSetup>
                            </Router>
                        </ErrorBoundary>
                    </ThemeProvider>
                </RavenUserSetup>
            </ConnectedIntlProvider>
        </Provider>
    );
}

Root.propTypes = {
    store: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/root.js